import { createSlice } from "@reduxjs/toolkit";
import { Folder, FolderSeance } from "domain/entities/folders.entities";
import {
  addSeanceToFolder,
  createFolder,
  deleteFolder,
  getFolders,
  getFolderSeances,
  removeSeanceFromFolder,
  updateFolder,
} from "domain/folders/folders.actions";

export type FolderState = {
  folders: Folder[];
  isFoldersLoading: boolean;
  folderSeances: FolderSeance[];
};

const initialState: FolderState = {
  folders: [],
  isFoldersLoading: false,
  folderSeances: [],
};

export const foldersSlice = createSlice({
  name: "folders",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //GET FOLDERS
    builder.addCase(getFolders.fulfilled, (state, action) => {
      state.folders = action.payload.folders;
      state.isFoldersLoading = false;
    });
    builder.addCase(getFolders.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
    //CREATE FOLDER
    builder.addCase(createFolder.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.folder) {
        state.folders.push(action.payload.folder);
      }
      state.isFoldersLoading = false;
    });
    builder.addCase(createFolder.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
    //UPDATE FOLDER
    builder.addCase(updateFolder.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.folder) {
        const folder = state.folders.find(
          (folder) => folder.id === action.payload.folder.id
        );
        folder.label = action.payload.folder.label;
      }
      state.isFoldersLoading = false;
    });
    builder.addCase(updateFolder.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
    //GET FOLDER SEANCES
    builder.addCase(getFolderSeances.fulfilled, (state, action) => {
      state.folderSeances = action.payload.seances;
      state.isFoldersLoading = false;
    });
    builder.addCase(getFolderSeances.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
    //DELETE FOLDER
    builder.addCase(deleteFolder.fulfilled, (state, action) => {
      state.folders = state.folders.filter(
        (f) => f.id !== action.payload.folderId
      );
      state.isFoldersLoading = false;
    });
    builder.addCase(deleteFolder.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
    //ADD SEANCE TO FOLDER
    builder.addCase(addSeanceToFolder.fulfilled, (state, action) => {
      state.isFoldersLoading = false;
    });
    builder.addCase(addSeanceToFolder.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
    //REMOVE SEANCE FROM FOLDER
    builder.addCase(removeSeanceFromFolder.fulfilled, (state, action) => {
      state.folderSeances = state.folderSeances.filter(
        (fs) => fs.id !== action.payload.folderSeanceId
      );
      state.isFoldersLoading = false;
    });
    builder.addCase(removeSeanceFromFolder.pending, (state, action) => {
      state.isFoldersLoading = true;
    });
  },
});
